import { PartnersLogin } from '../pages/protected/login/interfaces/partners-credentials.interface';
import { environment } from '../../environments/environment';

export const SONECT_LOGIN_CREDENTIALS: Partial<PartnersLogin> = {
  // Lottomatica
  DEV: {
    clientId: environment.lottomatica.clientId || '',
    clientSecret: environment.lottomatica.clientSecret || '',
    referenceId: 'dev300501',
    pwo: {
      clientId: environment.pwo?.clientId || '',
      clientSecret: environment.pwo?.clientSecret || '',
      referenceId: 'dev300501',
    },
    totosi: {
      clientId: environment.totosi?.clientId || '',
      clientSecret: environment.totosi?.clientSecret || '',
      referenceId: 'dev300501',
    }
  },
  TEST: {
    clientId: environment.lottomatica.clientId || '',
    clientSecret: environment.lottomatica.clientSecret || '',
    referenceId: 'web300503',
    pwo: {
      clientId: environment.pwo?.clientId || '',
      clientSecret: environment.pwo?.clientSecret || '',
      referenceId: 'web300503',
    },
    totosi: {
      clientId: environment.totosi?.clientId || '',
      clientSecret: environment.totosi?.clientSecret || '',
      referenceId: 'web300503',
    }
  }
};
